/** @jsxImportSource @emotion/react */
import React from "react";
import { ReactComponent as ViewTransactionIcon } from "../../../img/trade-interface/view_transaction_white.svg";
import { BLOCK_EXPLORER_URL_BY_NETWORK } from "../../../config/consts";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { viewOnExplorerLinkStyle } from "../SwapAndSendStyle";

export enum ViewOnExplorerDisplayLocations {
  "Entry" = "Entry",
  "Review" = "Review",
  "Confirm" = "Confirm",
}
interface ViewOnExplorerProps {
  visible: boolean;
  address: string;
  displayLocation: ViewOnExplorerDisplayLocations;
}

export const ViewOnExplorer: React.FC<ViewOnExplorerProps> = ({
  visible,
  address,
  displayLocation,
}) => {
  const network = GlobalStore.useState(s => s.network);
  const addMargin = displayLocation === ViewOnExplorerDisplayLocations.Entry;
  if (!visible) {
    return null;
  }

  return (
    <a
      href={`${BLOCK_EXPLORER_URL_BY_NETWORK[network.id]}address/${address}`}
      css={addMargin && viewOnExplorerLinkStyle}
      target="_blank"
      rel="noreferrer nofollow"
    >
      <ViewTransactionIcon width="20" height="20" />
    </a>
  );
};
